import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=0f837204&"
import script from "./Puzzle.vue?vue&type=script&lang=js&"
export * from "./Puzzle.vue?vue&type=script&lang=js&"
import style0 from "./Puzzle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f837204')) {
      api.createRecord('0f837204', component.options)
    } else {
      api.reload('0f837204', component.options)
    }
    module.hot.accept("./Puzzle.vue?vue&type=template&id=0f837204&", function () {
      api.rerender('0f837204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/svgs/Puzzle.vue"
export default component.exports